import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import SignalManager from './SignalManager';

type SignalDialogProps = {
  open: boolean;
  onClose: () => void;
};

const SignalDialog: FC<SignalDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Signals</DialogTitle>
      <DialogContent>
        <SignalManager />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignalDialog;
